import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 20px;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-style: normal;
    font-weight: 275;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
    }
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
  margin: 0 20px;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  max-width: 1180px;
  margin: 120px auto 80px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    max-width: 340px;
    margin: 24px auto 20px;
  }

  p {
    font-size: 24px;
    font-style: normal;
    font-weight: 300;
    line-height: 32px;
  }
`;

export const TextBox1 = styled.div`
  text-align: left;
  font-size: 24px;
  font-style: normal;
  line-height: 28px;
  color: #fcfcfc;

  @media (max-width: 768px) {
    text-align: left;
    font-size: 20px;
    font-style: normal;
    font-weight: 275;
    line-height: 24px;
  }

  p {
    @media (max-width: 768px) {
      font-size: 20px;
      font-style: normal;
      font-weight: 275;
      line-height: 24px;
    }
  }

  .first-paragraph {
    margin-bottom: 30px;
  }
`;

export const TextBox2 = styled.div`
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #c3c3c3;
  margin-bottom: 20px;

  p {
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    text-align: left;
    margin-bottom: 20px;

    span:nth-child(1) {
      color: #1cac74;
    }

    span:nth-child(2) {
      color: #ffc46b;
    }

    span:nth-child(3) {
      color: #f1614c;
    }

    @media (max-width: 768px) {
      text-align: left;
      margin-bottom: 0;
    }
  }
`;

export const ImageBox = styled.div`
  width: 100%;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    margin-bottom: 30px;
  }

  img {
    max-width: 100%;
    height: auto;
    object-fit: cover;
  }
`;

export const ApplicationExampleText = styled.p`
  text-align: left;
  font-size: 24px;
  font-weight: 300;
  color: #c3c3c3;
  margin: 40px 0;

  @media (max-width: 768px) {
    font-size: 18px;
    margin: 20px 0;
  }
`;
